import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { GUNSONU_WHATSAPP_SETTINGS_ID, normalizePhoneForWhatsapp } from './gunsonuWhatsappReport';

export function gunsonuWhatsappSettingsRef(sube) {
  return doc(db, 'subeler', sube, 'ayarlar', GUNSONU_WHATSAPP_SETTINGS_ID);
}

export async function loadGunsonuWhatsappSettings(sube) {
  if (!sube) {
    return { enabled: true, recipients: [] };
  }
  const snap = await getDoc(gunsonuWhatsappSettingsRef(sube));
  if (!snap.exists()) {
    return { enabled: true, recipients: [] };
  }
  const data = snap.data() || {};
  const list = Array.isArray(data.recipients) ? data.recipients : [];
  return {
    enabled: data.enabled !== false,
    recipients: list
      .map((r) => ({
        id: String(r.id || ''),
        name: String(r.name || '').trim(),
        phone: String(r.phone || '').trim(),
      }))
      .filter((r) => r.id && r.phone),
  };
}

/** @deprecated use loadGunsonuWhatsappSettings */
export async function loadGunsonuWhatsappRecipients(sube) {
  const settings = await loadGunsonuWhatsappSettings(sube);
  return settings.recipients;
}

export async function saveGunsonuWhatsappRecipients(sube, recipients, enabled = true) {
  if (!sube) throw new Error('Şube eksik');
  const cleaned = (recipients || [])
    .map((r) => ({
      id: String(r.id || crypto.randomUUID()),
      name: String(r.name || '').trim() || 'Alıcı',
      phone: String(r.phone || '').trim(),
    }))
    .filter((r) => normalizePhoneForWhatsapp(r.phone));

  await setDoc(
    gunsonuWhatsappSettingsRef(sube),
    {
      enabled: enabled !== false,
      recipients: cleaned,
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  return cleaned;
}
